import type { ReactNode } from 'react'

type FormFieldProps = {
  label: string
  htmlFor?: string
  required?: boolean
  children: ReactNode
  hint?: string
}

export function FormField({ label, htmlFor, required, children, hint }: FormFieldProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <label
        htmlFor={htmlFor}
        className="text-xs font-semibold text-[var(--color-text)]"
      >
        {label}
        {required ? <span className="ml-0.5 text-red-500">*</span> : null}
      </label>
      {children}
      {hint ? <p className="text-xs text-[var(--color-text-muted)]">{hint}</p> : null}
    </div>
  )
}
